import { Drawer, Grid2 } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useParams } from "react-router-dom";
import { StandardButton } from "../../_components/button/primary.button";
import { DrawerHeader } from "../../_components/drawer/header.drawer";
import { StandardTextValidator } from "../../_components/textValidator/standardTextValidator";
import { toastr } from "../../_components/toastr/toastr";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { DataTypeEnum } from "../../_common/enum/dataType.enum";
import { DataTypeAutoComplete } from "../../_components/autocomplete/dataType.autocomplete";
import { IClientManage } from "../../_common/models/client/clientManage.model";
import { clientService } from "../../_services/client.service";
import { getFormatedDate } from "../../_helpers/dateTime.helper";

export const ClientManageDrawer = (params: { isOpen?: boolean, onSave(): void, onClose(): void }) => {
    const { id } = useParams<{ id: string }>();

    const resetData = (): IClientManage => ({
        id: id ? Number(id) : 0,
        fName: '',
        lName: '',
        centreId: 0,
        nickname: '',
        phone: '',
        dob: '',
        height: null,
        weight: null,
        mobilePhone: '',
        medicalCardNo: '',
        medicalCardExpiry: '',
        allergies: '',
        eyeColourId: null,
        hairColourId: null,
        ethnicOriginId: null,
        careStatusId: null,
        genderId: 0,
        bodyTypeId: null,
        ppsn: '',
        dateOfAdmission: '',
        primaryKeyWorkerId: null,
        secondaryKeyWorkeryId: null,
        lhoAreaId: null,
        email: '',
        complexionId: null,
        caseManagerId: null,
        distinguishingFeatures: '',
        noOfExistingSENs: 0,
        initials: '',
        isActive: true
    });

    const [data, setData] = useState<IClientManage>(resetData);
    const [isLoading, setIsLoading] = useState(false);
    const [saving, setIsSaving] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
            setData(resetData);
    }, [id]);

    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);
        return  clientService
            .submit(data)
            .then(
                () => {
                    toastr.success("Saved successfully");
                    resetData();
                    params.onSave();
                }, handleErrorResponse
            )
            .finally(() => setIsSaving(false));
    }

    function handleChange(event: any) {
        setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }));
    }

    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={"Create Client"} onClose={params.onClose} />

            <ValidatorForm
                onSubmit={submit}
                noValidate>

                <Grid2 container spacing={1} sx={{ "padding": "8px" }}>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            key="fName"
                            name="fName"
                            label="First Name"
                            required
                            fullWidth
                            validators={['required', 'minStringLength:1']}
                            errorMessages={['required field', "Field cannot be empty"]}
                            value={data.fName}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            key="lName"
                            name="lName"
                            label="Last Name"
                            required
                            fullWidth
                            validators={['required', 'minStringLength:1']}
                            errorMessages={['required field', "Field cannot be empty"]}
                            value={data.lName}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            key="initials"
                            name="initials"
                            label="Initials"
                            fullWidth
                            value={data.initials}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            key="nickname"
                            name="nickname"
                            label="Nickname"
                            fullWidth
                            value={data.nickname}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            key="email"
                            name="email"
                            label="Email"
                            fullWidth
                            value={data.email}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            key="phone"
                            name="phone"
                            label="Phone"
                            fullWidth
                            value={data.phone}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            key="mobilePhone"
                            name="mobilePhone"
                            label="Mobile"
                            fullWidth
                            value={data.mobilePhone}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            name="dob"
                            label="Date Of Birth"
                            required
                            fullWidth
                            type="date"
                            errorMessages={['required field', "Field cannot be empty"]}
                            value={getFormatedDate(data.dob)}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <DataTypeAutoComplete
                            name="genderId"
                            label="Gender"
                            required
                            value={data.genderId}
                            onChange={handleChange} dataType={DataTypeEnum.Genders} />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            key="height"
                            name="height"
                            label="Height(cm)"
                            type="number"
                            fullWidth
                            value={data.height}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            key="weight"
                            name="weight"
                            label="Weight(kg)"
                            type="number"
                            fullWidth
                            value={data.weight}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            key="distinguishingFeatures"
                            name="distinguishingFeatures"
                            label="Distinguishing Features"
                            fullWidth
                            value={data.distinguishingFeatures}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <DataTypeAutoComplete
                            name="bodyTypeId"
                            label="Body Type"
                            value={data.bodyTypeId}
                            onChange={handleChange} dataType={DataTypeEnum.BodyTypes} />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <DataTypeAutoComplete
                            name="complexionId"
                            label="Complexion"
                            value={data.complexionId}
                            onChange={handleChange} dataType={DataTypeEnum.Complexions} />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <DataTypeAutoComplete
                            name="eyeColourId"
                            label="Eye Colour"
                            value={data.eyeColourId}
                            onChange={handleChange} dataType={DataTypeEnum.EyeColours} />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <DataTypeAutoComplete
                            name="hairColourId"
                            label="Hair Colour"
                            value={data.hairColourId}
                            onChange={handleChange} dataType={DataTypeEnum.HairColours} />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <DataTypeAutoComplete
                            name="ethnicOriginId"
                            label="Ethnic Origins"
                            value={data.ethnicOriginId}
                            onChange={handleChange} dataType={DataTypeEnum.EthnicOrigins} />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            key="ppsn"
                            name="ppsn"
                            label="PPSN"
                            fullWidth
                            value={data.ppsn}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            key="medicalCardNo"
                            name="medicalCardNo"
                            label="Medical Card No."
                            fullWidth
                            value={data.medicalCardNo}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            name="medicalCardExpiry"
                            label="Medical Card Expiry"
                            fullWidth
                            type="date"
                            value={getFormatedDate(data.medicalCardExpiry)}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            key="allergies"
                            name="allergies"
                            label="Allergies"
                            fullWidth
                            value={data.allergies}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            key="noOfExistingSENs"
                            name="noOfExistingSENs"
                            label="No of Existing SENs"
                            type="number"
                            required
                            fullWidth
                            value={data.noOfExistingSENs}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <DataTypeAutoComplete
                            name="lhoAreaId"
                            label="LHO Area"
                            value={data.lhoAreaId}
                            onChange={handleChange} dataType={DataTypeEnum.LHOAreas} />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <DataTypeAutoComplete
                            name="careStatusId"
                            label="Care Status"
                            value={data.careStatusId}
                            onChange={handleChange} dataType={DataTypeEnum.CareStatuses} />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <DataTypeAutoComplete
                            name="centreId"
                            label="Centre"
                            required
                            value={data.centreId}
                            onChange={handleChange} dataType={DataTypeEnum.Centres} />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            name="dateOfAdmission"
                            label="Date Of Admission"
                            fullWidth
                            type="date"
                            value={getFormatedDate(data.dateOfAdmission)}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <DataTypeAutoComplete
                            name="primaryKeyWorkerId"
                            label="Primary Key Worker"
                            value={data.primaryKeyWorkerId}
                            onChange={handleChange} dataType={DataTypeEnum.Users} />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <DataTypeAutoComplete
                            name="secondaryKeyWorkeryId"
                            label="Secondary Key Worker"
                            value={data.secondaryKeyWorkeryId}
                            onChange={handleChange} dataType={DataTypeEnum.Users} />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <DataTypeAutoComplete
                            name="caseManagerId"
                            label="Case Manager"
                            value={data.caseManagerId}
                            onChange={handleChange} dataType={DataTypeEnum.Users} />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <Grid2 container spacing={1}>
                            <Grid2 size={{ xs: 12 }}>
                                <StandardButton
                                    saving={saving}
                                    loading={isLoading}
                                    icon="save"
                                    type="submit">
                                    Save
                                </StandardButton>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </Grid2>

            </ValidatorForm>
        </Drawer>
    );
};